export default defineNuxtRouteMiddleware(async () => {
  const { authenticatedTemp } = useAuthenticatedTemp()

  if (!authenticatedTemp.value) {
    return navigateTo('/')
  }
})
